import React, { useState, useEffect, useContext } from "react";
import { makeStyles, IconButton } from "@material-ui/core";

import QuickMessageDialog from "../../components/QuickMessageDialog";
import ConfirmationModal from "../../components/ConfirmationModal";

import { i18n } from "../../translate/i18n";
import { toast } from "react-toastify";

import useQuickMessages from "../../hooks/useQuickMessages";
import { AuthContext } from "../../context/Auth/AuthContext";
import TableManager from "../../components/TableManager/TableManager";
import HeaderManager from "../../components/HeaderTableManager/HeaderTableManager";
import PencilEditIcon from "../../assets/icon/PencilEditIcon";
import TrashIcon from "../../assets/icon/TrashIcon";
import AddIcon from "../../assets/icon/AddIcon";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  tableContainer: {
    width: '100%',
    maxWidth: '80%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '90%',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '90%'
    },
  },
}));

function QuickMessages() {
  const [messages, setMessages] = useState([]);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [messageSelected, setMessageSelected] = useState({});
  const [showOnDeleteDialog, setShowOnDeleteDialog] = useState(false);

  const {
    list: listMessages,
    save: saveMessage,
    update: updateMessage,
    deleteRecord: deleteMessage,
    loading: loadingSave,
  } = useQuickMessages();

  const { user } = useContext(AuthContext);

  useEffect(() => {
    loadingQuickMessages();
  }, []);

  const loadingQuickMessages = async (forceUpdate = false) => {
    console.log('entro en loadingQuickMessages');
    setLoading(true);
    try {
      const companyId = localStorage.getItem("companyId");
      const messages = await listMessages({ companyId, userId: user.id }, forceUpdate);
      setMessages(messages);
    } catch (e) {
      toast.error(e);
    }
    setLoading(false);
  };

  const handleOpenToAdd = () => {
    setMessageSelected({ id: null, message: "", shortcode: "" });
    setModalOpen(true);
  };

  const handleOpenToEdit = (message) => {
    setMessageSelected(message);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setMessageSelected({ id: null, message: "", shortcode: "" });
  };

  const handleSave = async (message) => {
    try {
      const result = await saveMessage(message);
      if (result?.list) setMessages(result.list);
      toast.success("El mensaje rápido se ha creado correctamente");
    } catch (e) {
      toast.error(e.response?.data?.error);
    }
  };

  const handleEdit = async (message) => {
    try {
      const result = await updateMessage(message);
      if (result?.list) setMessages(result.list);
      toast.success("El mensaje rápido se ha editado correctamente");
    } catch (e) {
      toast.error("Error al editar el mensaje rápido");
    }
  };

  const handleDelete = async (message) => {
    handleCloseModal();
    try {
      const result = await deleteMessage(message.id);
      if (result?.list) setMessages(result.list);
      toast.success("El mensaje rápido se ha eliminado correctamente");
    } catch (e) {
      toast.error(e);
    }
  };

  const primaryButtons = [
    { label: i18n.t("quickMessages.buttons.add"), onClick: handleOpenToAdd, icon: <AddIcon fill='#000' /> },
  ];

  const columns = [
    { field: 'shortcode', headerName: i18n.t("quickMessages.table.shortcode"), headerStyle: {fontWeight: '400'},width: '40%' },
    { field: 'message', headerName: i18n.t("quickMessages.table.message"),headerStyle: {fontWeight: '400'},width: '40%' },
  ];

  const actionButtons = [
    ({ row }) => (
      <IconButton size="small" onClick={() => handleOpenToEdit(row)}>
        <PencilEditIcon fill="#7F7F7F" />
      </IconButton>
    ),
    ({ row }) => (
      <IconButton
        size="small"
        onClick={() => {
          setMessageSelected(row);
          setShowOnDeleteDialog(true);
        }}
      >
        <TrashIcon fill="#7F7F7F" />
      </IconButton>
    ),
  ];

  return (
    <>
      <div className={classes.mainContainer} >
        <div className={classes.tableContainer}>
          <HeaderManager
            title={i18n.t("quickMessages.title")}
            primaryButtons={primaryButtons}
          />
          <TableManager
            columns={columns}
            data={messages}
            loading={loading}
            actionButtons={actionButtons}
          />
        </div>
        <QuickMessageDialog
          messageSelected={messageSelected}
          modalOpen={modalOpen}
          onClose={handleCloseModal}
          editMessage={handleEdit}
          saveMessage={handleSave}
          loadingSave={loadingSave}
        />
        <ConfirmationModal
          title="Eliminar respuesta rápida"
          open={showOnDeleteDialog}
          onClose={() => setShowOnDeleteDialog(false)}
          onConfirm={async () => {
            await handleDelete(messageSelected);
            setShowOnDeleteDialog(false);
          }}
        >
          ¿Estás seguro de querer eliminar esta respuesta rápida?
        </ConfirmationModal>
      </div>
    </>
  );
}

export default QuickMessages;